import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import { Banner } from "./Banner";

import meditation from "../assets/img/meditation.jpg";
import ames from "../assets/img/ames.jpg";
import bebe from "../assets/img/bebe3.jpg";
import channeling from "../assets/img/channeling.jpg";
import jane from "../assets/img/jane.jpeg";

import spotify from "../assets/logo/spotify.png";
import deezer from "../assets/logo/deezer-logo-coeur.png";
import apple from "../assets/logo/apple.png";
import amazon from "../assets/logo/amazon_music.png";
import youtube from "../assets/logo/ytb.png";

import lumiere from "../assets/img/lumiere_album.jpg";
import rim from "../assets/img/rim.jpg";

export const Home = () => {
  return (
    <>
      <Banner />

      <div className="block-container">
        <div className="home-about-container">
          <div>
            <img src={jane} className="jane-img jane-img-home" />
          </div>
          <div>
            <p className="home-about-p bio-container">
              Aujourd'hui, avec <strong>l'éveil des consciences</strong>, nous
              cherchons des <strong>solutions alternatives</strong> pour être au
              top de notre forme physique, mentale, psychologique et
              spirituelle. J'ai conçu ce site pour vous présenter 4{" "}
              <strong>clés</strong> <strong>accessibles</strong> à tous. Elles
              réveilleront dans les profondeurs de votre Être le souvenir et la
              capacité du <strong>bonheur</strong>.{" "}
            </p>
          </div>
        </div>

        <div className="book-home-container">
          <h2 className="book-home-title">
            Mon nouveau livre est en préparation
          </h2>

          <p className="home-about-p book-home-text">
            Mon nouveau livre est actuellement en préparation. Je vous laisse
            découvrir les vidéos en attendant sa sortie.
          </p>

          <div className="bouton-rectangle-container">
            <Link to="/nouveau-livre" className="bouton-rectangle-auteure">
              Regarder les vidéos
            </Link>
          </div>
        </div>

        <div className="cles-container">
          <h2 className="text-center cles-titre">
            Les 4 clés énergétiques et spirituelles
          </h2>

          <Row className="align-items-center">
            <Col xs={12} lg={6} className="d-flex justify-content-center">
              <Link to={"/meditation"}>
                <div className="image-container-sp">
                  <img
                    src={meditation}
                    alt="Image"
                    className="image-hover-zoom"
                  />
                  <div className="image-overlay-sp">
                    <p className="titre-sp">Méditation</p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col xs={12} lg={6} className="d-flex justify-content-center">
              <Link to={"/channeling"}>
                <div className="image-container-sp">
                  <img
                    src={channeling}
                    alt="Image"
                    className="image-hover-zoom"
                  />
                  <div className="image-overlay-sp">
                    <p className="titre-sp">Channeling</p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col xs={12} lg={6} className="d-flex justify-content-center">
              <Link to={"/accueil-nouveaux-nes"}>
                <div className="image-container-sp">
                  <img src={bebe} alt="Image" className="image-hover-zoom" />
                  <div className="image-overlay-sp">
                    <p className="titre-sp">Accueil des nouveaux nés</p>
                  </div>
                </div>
              </Link>
            </Col>
            <Col xs={12} lg={6} className="d-flex justify-content-center">
              <Link to={"/passage-d-ames"}>
                <div className="image-container-sp">
                  <img src={ames} alt="Image" className="image-hover-zoom" />
                  <div className="image-overlay-sp">
                    <p className="titre-sp">Passage d'âme</p>
                  </div>
                </div>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="music-home-container">
          <div className="music-home-info-container">
            <h1> LUMIÈRE </h1>
            <Row className="align-items-center">
              <Col xs={12} xl={9}>
                <p
                  className="home-about-p right"
                  style={{ textAlign: "justify" }}
                >
                  L'album LUMIÈRE offre une plongée apaisante à travers 15
                  titres inédits. Les mélodies enveloppantes, les paroles
                  poétiques et les arrangements musicaux soigneusement signés
                  Rido Bayonne invitent au voyage. Émotion et légèreté
                  mélancolique se marient librement. Fruit d'une passion
                  d'écrire et d'une composition musicale libre, chaque chanson
                  raconte une histoire à travers des sonorités et des mots
                  méditatifs. Une expérience intimement touchante.
                </p>
              </Col>
              <Col xs={12} xl={3} className="album-img-container">
                <img src={lumiere} className="album-img" />
              </Col>
            </Row>

            <div className="bouton-rectangle-container">
              <Link to={"/musique"} className="bouton-rectangle-music">
                Découvrir plus sur ma musique
              </Link>
            </div>
          </div>
          <div className="music-container">
            <h3 className="text-center music-titre">
              Disponible sur toutes les plateformes musicales
            </h3>
            <Row className="justify-content-center justify-container">
              <Col xs={4} sm={2} className="center-content-musique">
                {" "}
                <a
                  href="https://open.spotify.com/intl-fr/album/0pQ2xFwiX6DIn1ZHHMprO9?si=dgpEj_VISI65NChoNMRWWA"
                  target="_blank"
                >
                  <img src={spotify} className="logo-icon" />
                </a>{" "}
              </Col>
              <Col xs={4} sm={2} className="center-content-musique">
                {" "}
                <a
                  href="https://www.deezer.com/fr/album/258947952"
                  target="_blank"
                >
                  {" "}
                  <img src={deezer} className="logo-icon" />
                </a>{" "}
              </Col>
              <Col xs={4} sm={2} className="center-content-musique">
                {" "}
                <a
                  href="http://itunes.apple.com/album/id1744168659?ls=1&app=itunes"
                  target="_blank"
                >
                  {" "}
                  <img src={apple} className="logo-icon" />{" "}
                </a>
              </Col>
              <Col xs={4} sm={2} className="center-content-musique">
                {" "}
                <a
                  href="https://music.amazon.com/albums/B0D33PMYCQ?marketplaceId=A13V1IB3VIYZZH&musicTerritory=FR&ref=dm_sh_snheD3ydO0tssVpCV5hqW697g"
                  target="_blank"
                >
                  <img src={amazon} className="logo-icon amazon-logo" />{" "}
                </a>
              </Col>
              <Col xs={4} sm={2} className="center-content-musique">
                {" "}
                <a
                  href="https://www.youtube.com/watch?v=BVahOzJxzq0&list=OLAK5uy_nAdD4QCYR0TSgsiVeFNeYwo_ePDCbbhSM"
                  target="_blank"
                >
                  <img src={youtube} className="logo-icon" />
                </a>{" "}
              </Col>
            </Row>
          </div>
        </div>

        <div className="rim-container">
          <div className="rim-info-container">
            <h2 className="titre-rim">Auteure</h2>

            <Row className="align-items-center ">
              <Col xs={12} lg={3} className="album-img-container ">
                <img src={rim} className="jane-img" />
              </Col>
              <Col xs={12} lg={9}>
                <p className="home-about-p rim">
                  {" "}
                  Dans cet univers magique,{" "}
                  <strong className="line-return">Rim-la-Belle</strong> et ses
                  précieux alliés, nous invitent à écouter la sagesse de notre
                  propre cœur, à vivre en <strong>harmonie</strong> avec ceux
                  qui nous entourent. Nous apprenons à nous relier à notre{" "}
                  <strong>Terre</strong>, et à communiquer avec les{" "}
                  <strong>animaux</strong>, la <strong>nature</strong>, les{" "}
                  <strong>fleurs</strong>, les <strong>arbres</strong>, les{" "}
                  <strong>cristaux</strong>... et même avec ceux qui nous ont
                  quittés. Mots, images et musiques nous bercent et nous
                  appaisent.{" "}
                  <strong className="line-return">Rim-la-Belle</strong> offre
                  des réponses et des clés tout en réconfortant les enfants dans
                  leurs propres ressentis.
                </p>
              </Col>
            </Row>
            <div className="bouton-rectangle-container">
              <Link to={"/auteure"} className="bouton-rectangle-auteure">
                Découvrir plus sur le livre
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
